import { Text } from "@react-pdf/renderer";

const PdfTextBlock = ({ children }) => (
  <Text
    style={{
      fontSize: 9,
      marginBottom: 8,
      textAlign: "justify",
      lineHeight: 1.4,
    }}
  >
    {children}
  </Text>
);

export default PdfTextBlock;
